import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Forces the app to scroll to the top on every transition change
 * REFER TO https://stackoverflow.com/a/61602724
 */
export function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
